import CONTRATO_ESTIMACIONES from '@/graphql/querys/administracion/ejecucion/estimaciones/contratoEstimaciones.gql';

export default {
  methods: {
    mixCalcularPorcentajeFinanciero(contrato) {
      if (!contrato || !contrato.estimaciones || contrato.estimaciones.lenght <= 0) {
        return 0;
      }

      const { importeTotal } = contrato;
      const {
        importeCostoDirecto,
        importeCostoIndirectos,
        importeUtilidad,
        importeCargosAdicionales,
        importe: importeModificado,
      } = contrato.modificado;
      const importeContratoModificado = contrato.esObraFinanciada
        ? importeCostoDirecto + importeCostoIndirectos + importeUtilidad + importeCargosAdicionales
        : importeModificado;

      const importeEstimado = this.$ObjSumar(contrato.estimaciones, 'importeEstimado');

      return (importeEstimado / (importeTotal + importeContratoModificado)) * 100;
    },
    mixAvanceFinancieroALaFecha(fecha) {
      const noDatos = { fechaTermino: null, avance: 0 };
      if (!this.contratoEstimaciones) return noDatos;
      const aLaFecha = new Date(`${fecha}T00:00:00`);
      return (
        this.mixGetAvanceFinanciero
          .filter(({ fechaTermino }) => aLaFecha >= new Date(`${fechaTermino}T00:00:00`))
          .pop() || noDatos
      );
    },
  },
  apollo: {
    contratoEstimaciones: {
      query: CONTRATO_ESTIMACIONES,
      variables() {
        return {
          idContrato: this.$route.params.idContrato,
        };
      },
    },
  },
  computed: {
    getEstimaciones() {
      if (!this.contratoEstimaciones) return [];
      return this.contratoEstimaciones;
    },
    mixGetAvanceFinanciero() {
      if (!this.contratoEstimaciones) return [];

      let total = 0;

      return this.getEstimaciones
        .sort((a, b) => new Date(`${a.fechaAl}T00:00:00`) - new Date(`${b.fechaAl}T00:00:00`))
        .map((item) => {
          total += item.importeEstimado;
          return {
            fechaTermino: item.fechaAl,
            avance: this.$numberRound((total / this.importeDelContrato) * 100),
          };
        });
    },
  },
};
